var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.849,
    height: 184.894,
    viewBox: "0 0 182.849 184.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80c4ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-1283.315 -1336)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "%",
    transform: "translate(1375 1454.868)",
    fill: "#303041",
    fontSize: 73,
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.471,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M147.6,58.055l9.6,3.495-7.3,20.063,10.235,28.12L134.216,124.7l-10.235,28.12-29.471-5.2L68.594,162.583,49.359,139.659l-29.47-5.2V104.537L.653,81.613,19.888,58.689V28.763l29.471-5.2L68.595.643,94.51,15.606l29.471-5.2L134.216,38.53l25.916,14.963L157.2,61.55l-9.6-3.495L142.488,66.9,117.556,52.509l-6.914-19-19.908,3.51L73.227,26.916,60.233,42.4l-19.908,3.51V66.127L27.331,81.613,40.325,97.1v20.215l19.908,3.51L73.227,136.31,90.734,126.2l19.908,3.51,6.914-19,17.507-10.108-6.914-19L138,54.56l9.6,3.495L142.488,66.9Z",
    transform: "translate(1282.57 1360.415) rotate(-9)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/discounts.54b8826af2ca5aca5a75c8702b000bbc.svg";
export { ForwardRef as ReactComponent };